import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import type { UsersRouteParams } from '@openx/types/user.ts';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { UserDetails } from './components/UserDetails/UserDetails.tsx';

export const UserDetailsPage = () => {
  const { session } = useAuth();
  const { userId = '' } = useParams<UsersRouteParams>();
  const navigate = useNavigate();
  const isAllowed = isAdmin(session);

  const handleGoBack = useCallback(() => {
    navigate('/users');
  }, [navigate]);

  if (!isAllowed) return <AccessForbiddenPage />;

  return <UserDetails handleGoBack={handleGoBack} userId={userId} titlePrefix={'OpenXSelect'} />;
};
